var _path, _path2, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTraffic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circle",
    d: "M18 2.0845                 a 15.9155 15.9155 0 0 1 0 31.831                 a 15.9155 15.9155 0 0 1 0 -31.831"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "transparentcircle",
    d: "M18 2.0845                 a 15.9155 15.9155 0 0 1 0 31.831                 a 15.9155 15.9155 0 0 1 0 -31.831"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .circle { stroke: #fff; fill: none; stroke-width: 2.8; stroke-dasharray: 20 100; stroke-linecap: round;\n        animation: progress 700ms ease-out forwards; }\n        .transparentcircle { stroke: rgba(255,255,255,0.2); fill: none; stroke-width: 1.5; }\n\n        @keyframes progress { 0% { stroke-dasharray: 0 100; } }\n\n                ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraffic);
export default __webpack_public_path__ + "static/media/traffic.83296a10dfd2719ba40598b8a417b7db.svg";
export { ForwardRef as ReactComponent };